import { FC, PropsWithChildren } from "react";
import { MainContainer } from "./MainContainer";

export const MainPage: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return <MainContainer sx={{ minHeight: "100%" }}>{children}</MainContainer>;
};
